module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }